<template>
  <div class="main p-page1">

    <div class="c-cekajici-resene p-page1__wrap">
        <addEventBtn v-if="scenarioSelected && authorizedToAddEvent" @openEventEditModal="openEventEditModal"></addEventBtn>
        <TimerBar v-if="scenarioSelected" @on-scenario-editable="onScenarioEditable"></TimerBar>
        <messageController></messageController>
        <simulation-banner v-if="!scenarioSelected"> </simulation-banner>
          <bs-tabs v-else>
            <bs-tab :name="translate('Page1.text4')" :selected="true" :customHref="'waiting'">
              <div class="p-page1__row-item">
                <div class="c-cekajici-resene__item c-cekajici-resene__item--cekajici">
                  <div class="title">
                    <h1>{{ translate('Page1.text2') }}</h1>
                  </div>
                  <EventsList @openEventEditModal="openEventEditModal" :typeOfEventList="'waitingEvents'"></EventsList>

                </div>

              </div>
            </bs-tab>
            <!--<bs-tab :name="translate('Page1.text5')" :customHref="'alarms'">
              <div class="p-page1__row-item">
                  <div class="c-cekajici-resene__item c-cekajici-resene__item&#45;&#45;cekajici">
                      <div class="title">
                          <h1 id="waiting">{{ translate('Page1.text5').toLowerCase() }}</h1>
                      </div>
                      <EventsList @openEventEditModal="openEventEditModal" :typeOfEventList="'alarmsEvents'"></EventsList>
                  </div>
              </div>
            </bs-tab>-->
            <bs-tab :name="translate('Page1.text7')" :customHref="'solved'">
              <div class="p-page1__row-item">
                  <div class="c-cekajici-resene__item c-cekajici-resene__item--cekajici">
                      <div class="title">
                          <h1 id="waiting">{{ translate('Page1.text7').toLowerCase() }}</h1>
                      </div>
                      <EventsList @openEventEditModal="openEventEditModal" :typeOfEventList="'solvedEvents'"></EventsList>
                  </div>
              </div>
            </bs-tab>
            <bs-tab :name="translate('Page1.text8')" :customHref="'canceled'">
              <div class="p-page1__row-item">
                  <div class="c-cekajici-resene__item c-cekajici-resene__item--cekajici">
                      <div class="title">
                          <h1 id="waiting">{{ translate('Page1.text8').toLowerCase() }}</h1>
                      </div>
                      <EventsList @openEventEditModal="openEventEditModal" :typeOfEventList="'cancelledEvents'"></EventsList>
                  </div>
              </div>
            </bs-tab>
            <bs-tab :name="translate('Page1.text9')" :customHref="'forwarded'">
              <div class="p-page1__row-item">
                  <div class="c-cekajici-resene__item c-cekajici-resene__item--cekajici">
                      <div class="title">
                          <h1 id="waiting">{{ translate('Page1.text9').toLowerCase() }}</h1>
                      </div>
                      <EventsList @openEventEditModal="openEventEditModal" :typeOfEventList="'forwardedEvents'"></EventsList>
                  </div>
              </div>
            </bs-tab>
          </bs-tabs>
          <div v-if="scenarioSelected" class="p-page1__row-item">
            <div class="c-cekajici-resene__item c-cekajici-resene__item--resene">
              <div class="title">
                <h1 id="solved">{{ translate('Page1.text3') }}</h1>
              </div>
              <EventsList @openEventEditModal="openEventEditModal" :typeOfEventList="'assignedEvents'"></EventsList>

            </div>
          </div>
        </div>





    <!-- Right menu -->
    <div class="context-menu" id="context-menu" >
    </div>
    <!-- END Right menu -->
    <pageTitle :title="translate('Page1.text10')"> </pageTitle>
    <userBar> </userBar>

    <eventEditModal v-if="showEventEditModal"
                    @close="showEventEditModal = false"
                    :eventId="selectedEventId"
    > </eventEditModal>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import EventsList from '@/components/EventsList.vue';
  import TimerBar from '@/components/timerBar.vue';
  import bsTabs from '@/components/bsTabs.vue';
  import bsTab from '@/components/bsTab.vue';
  import userBar from '@/components/userBar.vue';
  import messageController from '@/components/messageController.vue';
  import addEventBtn from '@/components/addEventBtn.vue';
  import eventEditModal from '@/components/eventEditModal.vue';
  import pageTitle from "../components/pageTitle";
  import simulationBanner from "../components/simulationBanner";

  export default {
    name: "page1",
    components: {
      EventsList,
      TimerBar,
      bsTab,
      bsTabs,
      userBar,
      messageController,
      addEventBtn,
      eventEditModal,
      pageTitle,
      simulationBanner
    },
    data: function () {
      return {
        showEventEditModal: false,
        authorizedToAddEvent: false
      }
    },
    async mounted() {
      if(localStorage) {
        this.$store.commit('setEditMode', localStorage.getItem('editMode') === 'true');
      }
      
      this.authorizedToAddEvent = await this.isAuthorizedToAddEvent();
    },
    methods: {
      async openEventEditModal (eventId) {
        this.selectedEventId = eventId;
        this.showEventEditModal = true;
        await this.setSelectedEntities([eventId]);
      },
      async isAuthorizedToAddEvent(){
        const response = await this.authorizeCMD({cmd: (this.$store.state.editMode ? 'addEventScenario' : 'addEvent')});
        return response.authorizeCMD
      },
      async onScenarioEditable () {
          this.authorizedToAddEvent = await this.isAuthorizedToAddEvent()
      },
      ...mapActions(['authorizeCMD', 'setSelectedEntities'])
    },
    computed: {
      loaded(){
        return this.$store.state.loaded;
      },
      appState(){
        return this.$store.state.appState;
      },
      scenarioSelected(){
        return this.$store.state.scenarioSelected;
      }
    }
  }
</script>

<style lang="less">
  .p-page1 {
    &__wrap {

    }
    &__row-item {
      height: calc(~'50vh - 85px');
      margin: 5px 10px;
    }
  }
</style>
